<template>
    <div class="team">
        <Header msg='我的团队' type='Team' :isSearch='true'/>
        <!-- <Header msg='我的团队' type='Team' /> -->
        <Navbar :selected.sync="selected" :selecteData="selecteData" v-if="pageLevel >= 2"/>
        <div style="height:1rem;background:#f6f6fa" :style="pageLevel >= 2 ? 'height:1rem;' : 'height:0.5rem;' "></div>

        <router-view/>

        <!-- <div class="mask" v-show="showSearch" @touchmove.prevent>
          <div @click="hidemask" style="position: absolute;top:0;left:0;width:100%;height:100vh"></div>
          <div class="searchBox" @touchmove.prevent>
            <input type="text" class="searchInput" placeholder="搜索" v-model="userSearch"/>
            <mt-button @click.native="handleClick" size="large">确定</mt-button>
          </div>
        </div> -->
        <div class="mask" v-show="showSearch" style="background: rgba(0, 0, 0, 0.7);">
          <div class="seach-box">
            <van-search
                v-model.trim="userSearch"
                placeholder="请输入真实姓名或昵称..."
                show-action
                shape="round"
                @search="handleClick"
                style="height:0.5rem;">
                <div slot="action" @click="handleClick" style="color:#FABF01">搜索</div>
            </van-search>
            <img src="@/assets/home/Receive_icon_close@3x.png" class="mask-close" @click="hidemask()">
          </div>
        </div>
    </div>
</template>

<script>
import { Toast } from 'mint-ui';
import Header from '@/components/Header.vue';
import Navbar from '@/components/Navbar.vue';
import {myTeam, assistanceList, assistanceAdit} from '@/api';

export default {
    name: 'Team',
    components: {
      Header,
      Navbar,
    },
    data() {
      return {
        selected: 0, // Navbar索引
        selecteData: [{id: 1, name: '直接推荐', num: 0}, {id: 2, name: '间接推荐', num: 0}, {id: 3, name: '未审核', num: 0}], // Navbar数据
        pageLevel: -1, // 等级
        showSearch: false, // 显示搜索框
        userSearch: '', // 搜索词
      }
    },
    created() {
      this.pageLevel = this.$route.query.level;
      switch (window.location.pathname) {
        case "/Team/LevelOther":
          this.selected = 2;
          break;
        case "/Team/LevelOne":
          this.selected = 0;
          break;
        case "/Team/LevelTwo":
          this.selected = 1;
          break;
        default:
          break;
      }
      this.teamList();
    },
    watch:{
      getUserSearchStr(val) {
        this.showSearch = val;
      },
      selected(newVal, oldVal) {
        this.userSearch = '';
        this.handleRoute(newVal);
      }
    },
    computed: {
      getUserSearchStr() {
        return this.$store.state.search_str;
      }
    },
    methods: {
      // 获取统计数量
      teamList() {
        myTeam({level: 1, page:1, limit: 10}).then(res => {
          this.selecteData[0].num = res.data.headerCount.firstCount > 999 ? '999+' : res.data.headerCount.firstCount ? res.data.headerCount.firstCount : 0;
          this.selecteData[1].num = res.data.headerCount.secondCount > 999 ? '999+' : res.data.headerCount.secondCount ? res.data.headerCount.secondCount : 0;
          this.selecteData[2].num = res.data.headerCount.applyCount > 999 ? '999+' : res.data.headerCount.applyCount ? res.data.headerCount.applyCount : 0;
        });
      },
      // 搜索
      handleClick() {
        // if (this.userSearch) {
          this.$store.commit('searchStr', false);
          this.handleRoute(this.selected);
        // }
      },
      // 关闭搜索弹窗
      hidemask() {
        this.$store.commit('searchStr', false);
      },
      handleRoute(val) {
        window.scrollTo(0, 0);
        switch (val) {
          case 0:
            this.$router.replace({path:`/Team/LevelOne?level=${this.pageLevel}&kw=${this.userSearch}`})
            break;
          case 1:
            this.$router.replace({path:`/Team/LevelTwo?level=${this.pageLevel}&kw=${this.userSearch}`})
            break;
          case 2:
            this.$router.replace({path:`/Team/LevelOther?level=${this.pageLevel}&kw=${this.userSearch}`})
            break;
          default:
            break;
        }
      }
    }
}

</script>
<style lang='less'>
.team{
    min-height: 100vh;
    .Navbar{
      position: fixed;
      top:0.44rem;
      border-top: 0.5px solid #eeeeee;
      max-width: 640px;
    }

    .bar-one, .bar-two, .bar-three{
      // border-top: 1rem solid #f6f6fa; 
      background: white;
      height: auto;
      padding: 0 0.16rem;
      margin-bottom: 0.2rem;
      &>:last-child{
        border: none;
      }
      .item-box{
        flex-direction: column;
        text-align: left;
        line-height: 0.2rem;
      }
      .item-tags{
        border-radius: 2px;
        background: rgba(255, 221, 113, 0.2);
        color: #FA8801;
        padding: 0 6px;
        margin-right: 10px;
        font-size: 0.12rem;
        line-height: 0.16rem;
      }
      .item-phone{
        width: 0.11rem;
        height: 0.13rem;
        margin-right: 2px;
      }
    }



    .per-line{
      height: auto;
      line-height: 0.4rem;
      padding: 0.1rem 0;
    }
    .item-avatar{
        width: 0.56rem;
        height: 0.56rem;
        margin-right: 0.12rem;
        border-radius: 50%;
    }
    .item-name{
        font-size: 0.16rem;
        width:100%;
        margin-bottom: 0.1rem;
    }
    .item-time{
        color: #999999;
        font-size: 0.12rem;
        width: 100%;
        text-align: right;
        margin-bottom: 0.1rem;
    }
    .item-text{
        font-size: 0.14rem;
        color: white;
        width: 0.7rem;
        height: 0.24rem;
        line-height: 0.24rem;
        border-radius: 0.12rem;
        background: linear-gradient(90deg,#FABF01,#FA9901);
        text-align: center;
    }
    .item-texts{
      background: white;
      border: 1px solid #FABF01;
      color: #FABF01;
      margin-right: 0.1rem;
    }
    .searchBox{
      width: 100%;
      height: 1.2rem;
      background: white;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      padding: 0.1rem;
      .searchInput{
        outline-style: none ;
        border: 1px solid #ccc; 
        border-radius: 0.2rem;
        padding: 13px 14px;
        width: 100%;
        font-size: 14px;
        font-weight: 500;
        font-family: "Microsoft soft";
      }
    }
    .mint-button--large{
      width: 100%;
      margin: 0.1rem auto;
    }
}
.seach-box{
  width: 90%;
  padding: 0.16rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: white;
  border-radius: 0.1rem;
  &>div{
    border:none;
  }
  .mask-close{
    width: 0.3rem;
    height: 0.3rem;
    position: absolute;
    bottom: -0.5rem;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>